// Dense-UI design tokens — radius scale + button hierarchy.
//
// Why this exists: every dense-screen component (tables, forms, drawers,
// kanban/calendar/graph "New" buttons) used to hand-roll its own class
// string, and the primary action button was painted in the tenant's
// configurable ACCENTS color (core/theme.js). Enterprise tools (SAP,
// Workday, Jira) reserve color strictly for semantics — status, severity,
// delta sign — and use one neutral, high-contrast primary button
// everywhere else. Six possible "New" button colors reads as a theming
// demo, not a system of record.
//
// ACCENTS (theme.js) is unchanged and still owns: chart series, status/
// badge pills, entity-identity touches (the app avatar), and the active
// nav-item indicator — all genuinely semantic/wayfinding uses. This file
// only owns the "what do I click to act" hierarchy, which should look the
// same regardless of which accent an app's builder picked.
//
// Literal class strings only, same Tailwind-JIT constraint as ACCENTS.

export const BUTTONS = {
  // The one high-contrast action per screen (submit, create, save).
  primary:
    'bg-neutral-900 hover:bg-neutral-700 text-white ' +
    'dark:bg-white dark:hover:bg-neutral-200 dark:text-neutral-900',
  // Secondary actions (export, import, cancel-but-visible).
  secondary:
    'bg-neutral-100 hover:bg-neutral-200 text-neutral-700 border border-neutral-200 ' +
    'dark:bg-neutral-800 dark:hover:bg-neutral-700 dark:text-neutral-200 dark:border-neutral-700',
  // Icon-only / low-emphasis actions.
  ghost:
    'text-muted hover:bg-neutral-100 hover:text-neutral-900 ' +
    'dark:text-subtle dark:hover:bg-neutral-800 dark:hover:text-white',
  // Destructive confirmation actions.
  danger:
    'bg-red-600 hover:bg-red-500 text-white',
};

// Radius scale — dense chrome (tables, tab strips, panels) tones down from
// the rounded-xl/2xl "consumer app" feel toward the 6-8px range enterprise
// grids use. Badges/pills stay fully round (unaffected).
export const RADIUS = {
  container: 'rounded-lg',  // page-level panels, table wrappers
  control: 'rounded-md',    // buttons, inputs, dropdowns
};
